import { MonitoringInit } from 'js/components/Monitoring/Monitoring.js';
import { Polyfills } from 'js/components/Polyfills/Polyfills.js';
import { Analytics } from 'js/components/YextAnalytics/Analytics.js';
import { AccessibilityChecks } from 'js/components/Util/Accessibility.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { ImageObjectFit } from 'js/components/Image/index.js';
import { Throttle } from 'js/components/Util/Throttle.js';

import 'script-loader!node_modules/svg4everybody/dist/svg4everybody.min.js';

export class Global {
  static init() {
    Polyfills.init();
    MonitoringInit();

    OnReady(() => {
      Yext.Analytics = new Analytics(window);

      const thisYear = new Date().getFullYear();
      const dateSpans = document.querySelectorAll('.c-copy-date');
      for (const dateSpan of dateSpans) {
        dateSpan.innerHTML = `&copy; ${thisYear}`;
      }

      const backToTop = document.querySelector('.js-back-to-top');
      if (backToTop) {
        new Throttle('scroll', 'optimizedScroll', window).start();
        window.addEventListener('optimizedScroll', () => {
          const scrollPercentage = (document.documentElement.scrollTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
          if (backToTop.classList.contains('is-hidden') ? scrollPercentage > 0.2 : scrollPercentage <= 0.2) {
            backToTop.classList.toggle('is-hidden');
          }
        });
      }

      ImageObjectFit();
      svg4everybody();

      if (Yext.isStaging ||
          window.location.href.includes('yextpages') ||
          window.location.href.includes('localhost')) {
        AccessibilityChecks.checkAltTags();
      }
    });
  }
}
